import React from 'react';

const MernComp = () => {
    return (
        <>
            <div className="container-fluid">
                <div className="row mt-5">
                    <div className="col-lg-10 col-12 mx-auto">
                        {/* <div className="card-columns"> */}
                            <h1 className="text-center text-success">works in process. Stay tuned. Thank you</h1>
                        {/* </div> */}
                    </div>
                </div>
            </div>
        </>
    );
};

export default MernComp;